import { ArrowUpRightIcon } from '@heroicons/react/24/outline';
import { FC, useState } from 'react';

import { Dialog, DialogPanel, DialogTitle } from 'primitives/Dialog';

import { AccreditationCriteria } from './HelperComponents';

const MoreAccreditationDetailsDialogText: FC = () => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <>
      <div
        className="min-w-fit text-indigo-600 text-sm flex space-x-1 items-center cursor-pointer"
        onClick={() => setOpen(true)}
      >
        <span>Accreditation Criteria</span>
        <span>
          <ArrowUpRightIcon className="w-4 h-4" />
        </span>
      </div>
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <DialogPanel className="min-w-[720px]">
          <DialogTitle>Accreditation Eligibility Criteria</DialogTitle>
          <AccreditationCriteria />
        </DialogPanel>
      </Dialog>
    </>
  );
};

export default MoreAccreditationDetailsDialogText;
